import { __assign } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Box } from '../Box/index.js';
import { FlatLogoMark } from './FlatLogoMark.js';
import { GradientLogoMark } from './GradientLogoMark.js';
import { LogoMarkText } from './LogoMarkText.js';

var Logo = function (_a) {
    var _b = _a.tone, tone = _b === void 0 ? "primary" : _b, _c = _a.align, align = _c === void 0 ? "horizontal" : _c;
    var blockSVG = {
        "& svg": {
            display: "block",
        },
    };
    var alignmentStyles = {
        horizontal: __assign(__assign({}, blockSVG), { display: "flex", flexDirection: "row", alignItems: "center", gap: "5" }),
        vertical: __assign(__assign({}, blockSVG), { display: "flex", flexDirection: "column", alignItems: "center", gap: "2" }),
    };
    var logoMarkMapping = {
        primary: jsx(GradientLogoMark, {}),
        secondary: jsx(GradientLogoMark, {}),
        black: jsx(FlatLogoMark, { fill: "#000" }),
        white: jsx(FlatLogoMark, { fill: "#fff" }),
    };
    return (jsxs(Box, __assign({ sx: alignmentStyles[align] }, { children: [logoMarkMapping[tone], jsx(Box, __assign({ sx: { marginTop: "3px" } }, { children: jsx(LogoMarkText, { tone: tone }) }))] })));
};

export { Logo };
//# sourceMappingURL=Logo.js.map
